module.exports = __webpack_public_path__ + "img/پاکت-نامه1.22b81706.png";